export default __webpack_public_path__ + "static/media/557.f951f91a.png";